import Template from "app/models/template"
import Timeslot, { PatchTemplateTimeslotPayload, PostTemplateTimeSlotPayload } from "app/models/timeslot"
import { AxiosPromise } from "axios"
import { Params } from "app/redux/templates/templates.reducer"
import { planningApi } from "./api"

export const getTemplatesById = (id: number): AxiosPromise => planningApi(`/templates/${id}`)

export const getTemplates = (params?: Params): AxiosPromise => planningApi("/templates", { params })

export const putTemplates = (data: Template): AxiosPromise =>
  planningApi(`/templates/${data.id}`, {
    data,
    method: "PUT",
  })

export const deleteTemplatesById = (id: number): AxiosPromise =>
  planningApi(`/templates/${id}`, {
    method: "DELETE",
  })

export const postTemplates = (data: Template): AxiosPromise => planningApi("/templates", { method: "POST", data })

export const postTimeslots = (payload: {
  data: PostTemplateTimeSlotPayload & Pick<Timeslot, "employee">
  id: number
}): AxiosPromise =>
  planningApi(`/templates/${payload.id}/timeslots`, {
    data: [payload.data],
    method: "POST",
  })

export const patchTimeslots = (payload: { timeslot: PatchTemplateTimeslotPayload; templateId: number }): AxiosPromise =>
  planningApi(`/templates/${payload.templateId}/timeslots/${payload.timeslot.id}`, {
    data: payload.timeslot,
    method: "PATCH",
  })

export const patchConflicts = (payload: {
  templateId: number
  timeslotId: number
  conflictId: number
  status: string
}): AxiosPromise =>
  planningApi(`/templates/${payload.templateId}/timeslots/${payload.timeslotId}/conflicts/${payload.conflictId}`, {
    data: { status: payload.status },
    method: "PATCH",
  })

export const getTimeslots = (id: number): AxiosPromise => planningApi(`/templates/${id}/timeslots`)

export const deleteTimeslotsById = (templateId: number, id: number): AxiosPromise =>
  planningApi(`/templates/${templateId}/timeslots/${id}`, {
    method: "DELETE",
  })

export const getAvailabilities = (id: number, params: object): AxiosPromise =>
  planningApi(`/templates/${id}/availabilities`, {
    params,
  })

export const getWeekAvailabilities = (params: { templateId: string; sort?: string[] | undefined }): AxiosPromise =>
  planningApi(`/templates/${params.templateId}/week_availabilities`, {
    params,
  })

export const duplicateTemplate = (id: number, name: string): AxiosPromise =>
  planningApi(`/templates/${id}/duplicate`, {
    data: { name },
    method: "POST",
  })
